import type { RoleType } from '@/lib/rbac/roles';

// Mirrors copingTypeEnum in elixaa-core/packages/db/src/schema/clientCopingTypes.ts.
const COPING_TYPE_LABELS: Record<string, string> = {
  self_soothing: 'Self-Soothing',
  avoidance_healthy_distraction: 'Avoidance/Healthy Distraction',
  emotional_awareness: 'Emotional Awareness',
  mindfulness: 'Mindfulness',
  problem_solving: 'Problem-Solving',
  seeking_support: 'Seeking Support',
  learning_reflection: 'Learning & Reflection',
  spiritual_coping: 'Spiritual Coping',
  healthy_self_care: 'Healthy Self-Care',
  unhealthy_coping: 'Unhealthy Coping',
};

export const COPING_TYPE_OPTIONS = Object.entries(COPING_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const copingTypesLabel = (copingTypes: readonly string[]): string =>
  copingTypes.map((key) => COPING_TYPE_LABELS[key] ?? key).join(', ') || 'None';

const EDITOR_ROLES: readonly RoleType[] = ['psychologist', 'chief_psychologist'];
const VIEWER_ROLES: readonly RoleType[] = [
  ...EDITOR_ROLES,
  'volunteer',
  'ba_super_admin',
  'ba_admin',
  'super_admin',
];

export const canEditCopingTypes = (role: RoleType | null | undefined): boolean =>
  role != null && EDITOR_ROLES.includes(role);

export const canViewCopingTypes = (role: RoleType | null | undefined): boolean =>
  role != null && VIEWER_ROLES.includes(role);
